import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import akmApi from '../../../../../apis/akmApi';


import { Row, Col } from 'react-bootstrap';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,FormControl,InputLabel,Input,Box, Button, ButtonGroup} from '@material-ui/core';
import PaginationTable from '../../masterDropDown/PaginationTable';
import PaginationData from '../../../../../entity/PaginationData';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import PaketProgramEntity from '../../../../../entity/PaketProgramEntity';
import ListJadwalAndProfileCbt from './ListJadwalAndProfilCbt';

class ListPaketProgram extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            listPaketProgram: [],
            listKelasGroup: [],
            paginationData: PaginationData,
            isOpen : false,
            paketProgramEntity: PaketProgramEntity
            // result: props.responseListPaketProgram 
        }
    }

    async componentDidMount(){
        this.fetchPaketProgramAktif();
    }

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleCloseModal = async () =>{
        this.setState({isOpen : false});
    }

    fetchPaketProgramAktif = async (namaProgram) =>{
        this.setState({ isFetching: true });
        const result = await akmApi.post(URL_AKM.FETCH_PAKET_PROGRAM_AKTIF_LIST+'?page='+this.state.paginationData.page+'&size='+this.state.paginationData.size, {
            namaProgram: namaProgram
        })
            if(result){
                if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        listPaketProgram: result.data.data.content,
                        paginationData: {...this.state.paginationData, 
                            page: result.data.data.number,
                            size: result.data.data.size,
                            totalPages: result.data.data.totalPages,
                            numberOfElements: result.data.data.numberOfElements,
                            totalElements: result.data.data.totalElements
                        }
                    })
                } else {
                    this.setState({
                        listSoal: [],
                        paginationData:PaginationData,
                        showAlert: true,
                        resMessage: result.data.errorSchema.errorMessage    
                    })
                }
            this.setState({ isFetching: false });
        }
    }

    handleChangePage = async(newPage) => {
        this.state.paginationData.page = newPage;
        this.fetchPaketProgramAktif(this.state.namaProgram);
    }

    handleChangeRowsPerPage = (size) => {
        this.state.paginationData.page = 0;
        this.state.paginationData.size = size;
        this.fetchPaketProgramAktif(this.state.namaProgram);
    }

    formatDate(s){
        var options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(s).toLocaleTimeString([],options);
    }
    
    handleChangeNamePp= async (e) =>{
        const id = e.target.id;
        const val = e.target.value;
        this.fetchPaketProgramAktif(val);
    }

    render() { 
        const {paginationData, isOpen, listKelasGroup, paketProgramEntity} = this.state;
        return (
            <>
                <Row>
                    <Col sm={7}>
                        <Button variant="outlined" color="primary" onClick={() => this.props.handleOpenModal()}>
                            <AddIcon fontSize="small"/>Tambah PP
                        </Button>
                    </Col>
                    <Col align="right">
                        <FormControl>
                            <InputLabel htmlFor="standard-adornment-password">Cari Paket Program</InputLabel>
                            <Input
                                onChange={this.handleChangeNamePp}
                                placeholder="Cari Nama Paket Program"
                                id="namaProgram"
                                endAdornment={<SearchIcon position="end" />}
                            />
                        </FormControl>
                    </Col>
                </Row>
                <Row style={{marginTop: 25}}>
                    <Col>
                        <TableContainer component={Paper}>                    
                            <Table aria-label="collapsible table">
                                <TableHead>
                                <TableRow>
                                    <TableCell align="left">Nama Program</TableCell>
                                    <TableCell align="left">Harga</TableCell>
                                    <TableCell align="left">Prog Mulai</TableCell>
                                    <TableCell align="left">Prog Selesai</TableCell>
                                    <TableCell />
                                </TableRow>
                                </TableHead>
                                {this.renderRow()}
                            </Table>
                            <PaginationTable paging={paginationData} handleChangePage={this.handleChangePage} handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
                        </TableContainer>
                        
                    </Col>
                </Row>
            </>
        );
    }

    renderRow(){
        const {listPaketProgram, anchorEl} = this.state;
        var nf = new Intl.NumberFormat();
        return(
            <TableBody>
                {!__.isEmpty(listPaketProgram) &&
                    listPaketProgram.map((pp, i)=>
                        <TableRow key={i}>
                            <TableCell>{pp.namaProgram}</TableCell>
                            <TableCell>Rp. {nf.format(pp.harga)}</TableCell>
                            <TableCell>{this.formatDate(pp.startedDate)}</TableCell>
                            <TableCell>{this.formatDate(pp.expiredDate)}</TableCell>
                            <TableCell align="center">
                                {<div className="button-group">
                                    <ListJadwalAndProfileCbt paketProgram={pp} />
                                    <button className="btn btn-outline-info btn-sm" onClick={() => this.props.handleThrowPaketProgram(pp)}><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                    <button className="btn btn-outline-danger btn-sm" disabled><i className="fa fa-trash-o" aria-hidden="true"></i></button>								
                                    <button className="btn btn-outline-primary btn-sm" onClick={() => this.props.handleAddJadwal(pp)}><i className="fa fa-sliders" aria-hidden="true"></i></button>								
                                </div>}
                            </TableCell>
                        </TableRow>                    
                    )
                }
            </TableBody>
        )
    }
    
}
 
export default ListPaketProgram;